import t from 'react-translate';
import {
  MentoringProgramRole,
  MentorshipStatus,
} from 'redux/schemas/models/mentoring-program-enrollments';
import { black, danger, gray6, success, yellow } from 'styles/global_defaults/colors';
import { css } from '@emotion/react';
import { useContext } from 'react';
import { CellProps } from './types';
import { commonStyles } from './styles';
import { DEFAULT_CONCURRENT_MENTOR_CONNECTION } from '../../constants';
import MentoringProgramContext from '../../context';

const StatusCell = (props: CellProps) => {
  const { cell, className } = props;

  const {
    row: { original: mentoringProgramEnrollment },
  } = cell;
  const {
    mentorshipStatus,
    concurrentMentorConnection = DEFAULT_CONCURRENT_MENTOR_CONNECTION,
    assignedConnections = [],
    role,
  } = mentoringProgramEnrollment || {};
  const { name } = role || {};
  const isMentor = name === MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR;
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { mentorCapacityEnabled, concurrentMentorConnection: maxMentees } = mentoringProgram || {};

  const matchedSettings = {
    color: success,
    status: t.MENTORING_PROGRAMS.PARTICIPANTS.PARTICIPANT_ROW.MATCHED(),
  };
  const unmatchedSettings = {
    color: gray6,
    status: t.MENTORING_PROGRAMS.PARTICIPANTS.PARTICIPANT_ROW.UNMATCHED(),
  };
  const matchedWithCapacitySettings = {
    color: yellow,
    status:
      t.MENTORING_PROGRAMS.PARTICIPANTS.PARTICIPANT_ROW.MATCHED_WITH_CAPACITY(),
  };
  const matchedOverCapacitySettings = {
    color: danger,
    status:
      t.MENTORING_PROGRAMS.PARTICIPANTS.PARTICIPANT_ROW.MATCHED_OVER_CAPACITY(),
  };
  const statusMap = {
    [MentorshipStatus.MATCHED]: matchedSettings,
    [MentorshipStatus.UNMATCHED]: unmatchedSettings,
    [MentorshipStatus.MATCHED_WITH_CAPACITY]: isMentor
      ? matchedWithCapacitySettings
      : matchedSettings,
    [MentorshipStatus.MATCHED_OVER_CAPACITY]: isMentor
      ? matchedOverCapacitySettings
      : matchedSettings,
  };

  const { color, status } = statusMap[mentorshipStatus] || {};

  const styles = css`
    ${commonStyles};

    .indicator {
      width: 12px;
      height: 12px;
      border-radius: 12px;
      background-color: ${color};
    }

    .status {
      color: ${black};
    }
  `;

  const availableSlots = `(${assignedConnections.length}/${
    mentorCapacityEnabled ? concurrentMentorConnection : maxMentees
  })`;

  return (
    <div className={`d-flex align-items-center ${className}`} css={styles}>
      <div className='indicator mr-2' />
      <div className='text-medium semi-bold status mr-2'>{status}</div>
      {isMentor && <div className='text-small gray-2'>{availableSlots}</div>}
    </div>
  );
};

export default StatusCell;
